module.exports = __webpack_public_path__ + "img/bg.a35a91ac.png";